import classNames from 'classnames';
import React from 'react';

import FullProductMatrix from '../../../models/product/FullProductMatrix';
import { modelOf } from '../../../prop-types';

const ProductCollectionMatrixHeaderRow = ({ productMatrix }) => {
  const productRows = productMatrix.getDisplayColumns();
  const isLeftAligned = productMatrix.isLeftAligned;

  if (!productRows) {
    return null;
  }

  return (
    <thead className="ProductCollectionMatrixHeaderRow">
      <tr>
        {productRows[0].name && <th />}
        {productRows.map(
          (rowElement, index) =>
            rowElement.name && (
              <th
                key={index}
                className={classNames(
                  'ProductCollectionMatrixHeaderRow__row-element-title',
                  {
                    'ProductCollectionMatrixHeaderRow__row-element-title--left-aligned':
                      isLeftAligned,
                  }
                )}
                dangerouslySetInnerHTML={{ __html: rowElement.name }}
              />
            )
        )}
      </tr>
    </thead>
  );
};

ProductCollectionMatrixHeaderRow.propTypes = {
  productMatrix: modelOf(FullProductMatrix).isRequired,
};

export default ProductCollectionMatrixHeaderRow;
